import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const LOGIN_URL = process.env.REACT_APP_WEBSITE_URL
  ? `${process.env.REACT_APP_WEBSITE_URL.replace(/\/+$/, "")}/login`
  : "http://localhost:3002/login";

const PrivateRoute = () => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    const currentPath = `${location.pathname}${location.search}`;
    const allowedPrefixes = ["/app/", "/live-chat", "/auth/"];
    const safePath = allowedPrefixes.some(p => currentPath.startsWith(p)) ? currentPath : "/app/dashboard";
    window.location.href = `${LOGIN_URL}?redirect=${encodeURIComponent(safePath)}`;
    return null;
  }

  const role = user?.user?.role || user?.role;

  if (role === "agent" || role === "supervisor") {
    window.location.href = "/live-chat";
    return null;
  }

  return <Outlet />;
};

export default PrivateRoute;
